import { Grid, Button, csx } from '@vtex/admin-ui'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useHistory } from 'react-router'

import { SummarySection } from '../SummarySection'
import { DeadlineSection } from '../DeadlineSection/DeadlineSection'
import { PackageAddress } from '../AddressSection/AddressSection'
import { DetailedProductsList, StepTitle } from '../../../../components'
import { useOrderForm } from '../../../../../../core/requests/checkout'
import type { Package } from '../../../../../../core/typings'
import { CheckoutRoute } from '../../../../constants'
import { groupItemsWithAssemblyItems } from '../../../Cart/utils/groupItemsWithAssemblyItems'
import { CartSummaryItems } from '../../../../components/CartSummaryItems'

export type PackageSectionProps = {
  productPackage: Package
  packageNumber: number
}

export const PackageSection = ({
  productPackage,
  packageNumber,
}: PackageSectionProps) => {
  const history = useHistory()
  const { orderForm } = useOrderForm()
  const { formatMessage } = useIntl()

  const title = formatMessage(
    { id: 'checkout.order-summary.package.title' },
    { number: packageNumber }
  )

  const handleChangeDeliveryMethodClick = () => {
    history.push(
      `${CheckoutRoute.ShippingMethodSelection}?origin=order-summary`
    )
  }

  const items = groupItemsWithAssemblyItems(productPackage.items)

  return (
    <SummarySection
      data-testid="package-section"
      className={csx({
        marginTop: '$space-4',
        ':not(:last-child)': {
          borderBottom: '$neutral',
        },
        paddingBottom: '$space-4',
      })}
    >
      <Grid rowGap="1rem">
        <div
          className={csx({ justifyContent: 'space-between', display: 'flex' })}
        >
          <StepTitle
            aria-label="title-section"
            className={csx({
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            })}
          >
            {title}
          </StepTitle>
          <Button
            variant="tertiary"
            onClick={handleChangeDeliveryMethodClick}
            data-testid="change-package-button"
          >
            <FormattedMessage id="change" />
          </Button>
        </div>
        <DetailedProductsList>
          {items.map((item) => (
            <CartSummaryItems key={item.orderFormItem.index} item={item} />
          ))}
        </DetailedProductsList>
        <PackageAddress
          productPackage={productPackage}
          addressForDelivery={orderForm?.shippingData}
        />
        <DeadlineSection productPackage={productPackage} />
      </Grid>
    </SummarySection>
  )
}
